// ----------------------------------------------------------------------
// <copyright file="Izenda.IntegrationRoutes.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------
!(function () {
  var React = require('react');
  var Route = require('react-router').Route;
  var IndexRedirect = require('react-router').IndexRedirect;
  var Redirect = require('react-router').Redirect;
  var Config = require('config');
  var ReportRoutes = require('../modules/Reports/Izenda.ReportRoutes');
  var SettingsRoutes = require('../modules/Settings/Izenda.SettingsRoutes');
  var ReportDesignerRoutes = require('../modules/ReportDesigner/Izenda.ReportDesignerRoutes');
  var DashboardRoutes = require('../modules/Dashboard/Izenda.DashboardRoutes');
  var DashboardDesignerContainer = require('../modules/Dashboard/DashboardDesigner/Izenda.DashboardDesignerContainer');
  var ReportViewerContainer = require('../modules/Reports/ReportViewer/Izenda.ReportViewerContainer');
  var routeUtils = require('../share/utils/Izenda.RouteUtils');
  var IntegrationContainer = require('../Izenda.IntegrationContainer');
  var viewerRoute = require('../share/components/views/Izenda.ViewerRoute');
  var NoPermission = require('../share/components/controls/Izenda.NoPermission');
  var IntergrateStore = require('share/utils/Izenda.IntergrateStore');

  var IntegrationRoutes = function (mainRoute) {
    var BaseUrl = Config.BaseUrl || '/';
    var REPORT_VIEWER_ROUTE = routeUtils.getConfigRoute('ReportViewer');
    var REPORT_VIEWER__DETAIL_ROUTE = routeUtils.getConfigRoute('ReportViewer', 'ReportViewerDetail');
    var MAIN_ROUTE = mainRoute;
    var DASHBOARD_VIEWER_ROUTE = routeUtils.getConfigRoute('Dashboard');
    var DASHBOARD_VIEWER_DETAIL_ROUTE = routeUtils.getConfigRoute('Dashboard', 'DashboardViewer');
    var page = IntergrateStore.syncPageManifest();
    var reportViewerRedirectPath = `${BaseUrl}/${routeUtils.getConfigRoute('Report').path}/${routeUtils.getConfigRoute('Report', 'View').path}`;
    var dashboardViewerRedirectPath = `${BaseUrl}/${routeUtils.getConfigRoute('Dashboard').path}/${routeUtils.getConfigRoute('Dashboard', 'Edit').path}/`;

    return (
      <Route path={BaseUrl} component={IntegrationContainer}>
        <IndexRedirect to={MAIN_ROUTE.path} query= {MAIN_ROUTE.query}/>
        {SettingsRoutes()}
        {ReportDesignerRoutes()}
        {DashboardRoutes()}
        {ReportRoutes()}
        <Route path={REPORT_VIEWER_ROUTE.path}>
          <Redirect
          from={REPORT_VIEWER__DETAIL_ROUTE.path}
          to={reportViewerRedirectPath}
          state={{ page }} />
        </Route>
        <Route path={DASHBOARD_VIEWER_ROUTE.path}>
          <Redirect
            from={DASHBOARD_VIEWER_DETAIL_ROUTE.path}
            to={dashboardViewerRedirectPath}
            state={{ page }} />
        </Route>
          <Route path='NoPermission' component={NoPermission}></Route>
        {viewerRoute()}
      </Route>
    );
  };
  module.exports = IntegrationRoutes;
})();



// WEBPACK FOOTER //
// ./ui/routes/Izenda.IntegrationRoutes.jsx